import {v4 as uuidv4} from 'uuid';

const servicesOneData = [
    {
        id: uuidv4(),
        bg: '/img/services/construction.jpg',
        icon: '/img/services/construction.svg',
        title: 'Civil & MEP Services',
        desc: 'Complete civil construction and MEP engineering solutions for commercial and residential projects across Dubai.',
    },
    {
        id: uuidv4(),
        bg: '/img/services/maintenance.jpg',
        icon: '/img/services/maintenance.svg',
        title: 'AMC Services',
        desc: 'Reliable Annual Maintenance Contracts ensuring optimal performance and minimal downtime for all technical systems.',
    },
    {
        id: uuidv4(),
        bg: '/img/services/varnish.jpg',
        icon: '/img/services/varnish.svg',
        title: 'Painting Services',
        desc: 'Professional interior and exterior painting with premium materials and flawless surface preparation.',
    },
    {
    id: uuidv4(),
    bg: '/img/services/interior-design.jpg',
    icon: '/img/services/interior-design.svg',
    title: 'Interior Renovation',
    desc: 'Interior renovation involves upgrades and transforms existing spaces to improve function, efficiency, and modern aesthetics based on client needs.',
  },
    {
        id: uuidv4(),
        bg: '/img/services/fitout.jpg',
        icon: '/img/services/fitout.svg',
        title: 'Fitout Services',
        desc: 'We provide high-quality interior fit-out services, from ceilings and partitions to flooring and finishes, tailored to each client’s requirements.',
    },
    {
        id: uuidv4(),
        bg: '/img/services/air-conditioner.jpg',
        icon: '/img/services/air-conditioner.svg',
        title: 'AC Maintenance & Installation',
        desc: 'Expert AC installation, repair, and maintenance services for split, cassette, and central systems.',
    },
    {
        id: uuidv4(),
        bg: '/img/services/steel-structure.jpg',
        icon: '/img/services/steel-structure.svg',
        title: 'Steel Structure Works',
        desc: 'Precision steel fabrication, erection, and installation for industrial buildings, warehouses, and commercial structures.',
    },
    {
        id: uuidv4(),
        bg: '/img/services/flooring.jpg',
        icon: '/img/services/flooring.svg',
        title: 'Flooring Works',
        desc: 'Premium flooring solutions including tiles, vinyl, epoxy coating, and polished concrete for commercial spaces.',
    },
];



export default servicesOneData;